import request from '@/utils/request'

// 查询用户血糖记录列表
export function listUserBloodSugar(query) {
    return request({
        url: '/biz/userBloodSugar/list',
        method: 'get',
        params: query
    })
}

// 查询用户血糖记录详细
export function getUserBloodSugar(id) {
    return request({
        url: '/biz/userBloodSugar/' + id,
        method: 'get'
    })
}

// 新增用户血糖记录
export function addUserBloodSugar(data) {
    return request({
        url: '/biz/userBloodSugar',
        method: 'post',
        data: data
    })
}

// 修改用户血糖记录
export function updateUserBloodSugar(data) {
    return request({
        url: '/biz/userBloodSugar/update',
        method: 'post',
        data: data
    })
}

// 删除用户血糖记录
export function delUserBloodSugar(id) {
    return request({
        url: '/biz/userBloodSugar/delete/' + id,
        method: 'post'
    })
}
